export const evaluateExpression = (input) => {
    const avg = (...nums) => nums.reduce((a, b) => a + b, 0) / nums.length;
  
    const expr = input
      .replace(/min\(/g, "Math.min(")
      .replace(/max\(/g, "Math.max(")
      .replace(/pow\(/g, "Math.pow(")
      .replace(/sqrt\(/g, "Math.sqrt(")
      .replace(/avg\(/g, "avg(")
      .replace(/ln2/g, "Math.log(2)")
      .replace(/ln10/g, "Math.log(10)")
      .replace(/log2E/g, "Math.log2(Math.E)")
      .replace(/log10E/g, "Math.log10(Math.E)")
      .replace(/sqrt1\/2/g, "Math.sqrt(1/2)")
      .replace(/sqrt2/g, "Math.sqrt(2)")
      .replace(/floor\(/g, "Math.floor(")
      .replace(/round\(/g, "Math.round(")
      .replace(/abs\(/g, "Math.abs(")
      .replace(/ceil\(/g, "Math.ceil(")
      .replace(/exp\(/g, "Math.exp(")
      .replace(/sin\(/g, (_, angle) => `Math.sin(${angle} * Math.PI / 180)`)
      .replace(/cos\(/g, (_, angle) => `Math.cos(${angle} * Math.PI / 180)`)
      .replace(/asin\(/g, (_, val) => `Math.asin(${val}) * 180 / Math.PI`)
      .replace(/acos\(/g, (_, val) => `Math.acos(${val}) * 180 / Math.PI`)
      .replace(/random\((\d+),\s*(\d+)\)/g, (_, min, max) =>
        `Math.floor(Math.random() * (${max} - ${min} + 1)) + ${min}`
      )
      .replace(/secToMin\(([^)]+)\)/g, (_, v) => `(${v}) / 60`)
      .replace(/secToHours\(([^)]+)\)/g, (_, v) => `(${v}) / 3600`)
      .replace(/secToDays\(([^)]+)\)/g, (_, v) => `(${v}) / 86400`)
      .replace(/secToWeeks\(([^)]+)\)/g, (_, v) => `(${v}) / 604800`)
      .replace(/secToMonths\(([^)]+)\)/g, (_, v) => `(${v}) / 2628000`)
      .replace(/minToHours\(([^)]+)\)/g, (_, v) => `(${v}) / 60`)
      .replace(/minToDays\(([^)]+)\)/g, (_, v) => `(${v}) / 1440`)
      .replace(/minToWeeks\(([^)]+)\)/g, (_, v) => `(${v}) / 10080`)
      .replace(/minToMonths\(([^)]+)\)/g, (_, v) => `(${v}) / 43800`)
      .replace(/hoursToDays\(([^)]+)\)/g, (_, v) => `(${v}) / 24`)
      .replace(/hoursToWeeks\(([^)]+)\)/g, (_, v) => `(${v}) / 168`)
      .replace(/hoursToMonths\(([^)]+)\)/g, (_, v) => `(${v}) / 730`)
      .replace(/daysToWeeks\(([^)]+)\)/g, (_, v) => `(${v}) / 7`)
      .replace(/daysToMonths\(([^)]+)\)/g, (_, v) => `(${v}) / 30`);
  
    return eval(`(function() { return ${expr}; })()`);
  };
  